<template>
    <div class="disclaimers container">
      <div class="row">
        <div class="col-2 sidebar-left"></div>
        <div class="col-8">
          <div class="disclaimers-container">
            <div class="disclaimers-text" v-if="showFooterDisclaimer">
              <div v-html="footerDisclaimerText"></div>
            </div>
            <div class="disclaimers-logos">
              <img src="https://s3-us-west-2.amazonaws.com/pam3-public/fdic_member.svg" alt="FDIC Member" v-if="showFDIC" />
              <img src="https://s3-us-west-2.amazonaws.com/pam3-public/equal_housing_opportunity.svg" alt="Equal Housing Opportunity" v-if="showEHO" />
              <img src="https://s3-us-west-2.amazonaws.com/pam3-public/equal_housing_lender.svg" alt="Equal Housing Lender" v-if="showEHL" />
            </div>
          </div>
        </div>
        <div class="col-2 sidebar-right"></div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'DisclaimerFooter',
  components: {

  },
  props: {
    
  },
  computed: {
    showFooterDisclaimer: function () {
      if (this.$store.getters.getOfficerConfig)
        return this.$store.getters.getOfficerConfig.Disclaimers.ShowDisclaimerFooter
      if (this.$store.getters.getCompanyConfig)
        return this.$store.getters.getCompanyConfig.Disclaimers.ShowDisclaimerFooter
      return false
    },
    footerDisclaimerText: function () {
      if (this.$store.getters.getOfficerConfig)
        return this.$store.getters.getOfficerConfig.Disclaimers.DisclaimerFooter
      if (this.$store.getters.getCompanyConfig)
        return this.$store.getters.getCompanyConfig.Disclaimers.DisclaimerFooter
      return ''
    },
    showFDIC: function () {
      if (this.$store.getters.getOfficerConfig)
        return this.$store.getters.getOfficerConfig.Disclaimers.ShowFDICLogo
      if (this.$store.getters.getCompanyConfig)
        return this.$store.getters.getCompanyConfig.Disclaimers.ShowFDICLogo
      return false
    },
    showEHO: function () {
      if (this.$store.getters.getOfficerConfig)
        return this.$store.getters.getOfficerConfig.Disclaimers.ShowEqualHousingOpportunityLogo
      if (this.$store.getters.getCompanyConfig)
        return this.$store.getters.getCompanyConfig.Disclaimers.ShowEqualHousingOpportunityLogo
      return false
    },
    showEHL: function () {
      if (this.$store.getters.getOfficerConfig)
        return this.$store.getters.getOfficerConfig.Disclaimers.ShowEqualHousingLenderLogo
      if (this.$store.getters.getCompanyConfig)
        return this.$store.getters.getCompanyConfig.Disclaimers.ShowEqualHousingLenderLogo
      return false
    }
  }
}
</script>

<style scoped lang="scss">
  .disclaimers {
    margin-top: 40px;

    .disclaimers-container {
      display: flex;
      flex-direction: column;
      align-items: center;

      .disclaimers-text {
        text-align: center;
        margin-bottom: 20px;
      }

      .disclaimers-logos {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 200px;

        img {
          max-height: 50px;
          max-width: auto;
        }
      }
    }
  }
</style>
